import BaseHlsJsInteraction from './BaseHlsJsInteraction';
import { HLSjsInteractionOptions } from '../webrtc/bindHLSjsToWebRTC';
import detemplate from '../util/detemplate';
import logger from '../log';
import { HLS } from './interfaces';
import { MessageTemplates, PlayerNames } from '@kollective-frontend/ksdk-api';
import { checkType, Types } from '../util/checkTypes';

const { HLS_PLAYER } = PlayerNames;
const { IMPROPER_SETUP } = MessageTemplates;
const HLS_IMPROPER_SETUP = detemplate(IMPROPER_SETUP, { name: HLS_PLAYER });

const log = logger.getLogger(__filename);

export default class HLSjsInteraction extends BaseHlsJsInteraction<HTMLVideoElement> {
  constructor(
    videoEl: HTMLVideoElement,
    hls: HLS,
    option?: HLSjsInteractionOptions
  ) {
    super(videoEl, hls, option); // Player is an extended video element
    // We don't throw here as that would cascade out and crash the plugin.
    checkType(hls, Types.HLS).emitErrorIfNotCorrectType();
  }

  setSource(url: string): void {
    const result = checkType(this.hls, Types.HLS);
    if (result.isType && this.hls) {
      this.hls.loadSource(url);
      // the player in this case is the element
      this.hls.attachMedia(this.player);
    } else {
      result.log(log, log.ERROR, HLS_IMPROPER_SETUP);
    }
  }

  clearSource(): void {
    if (typeof this.hls?.detachMedia === 'function') {
      this.hls.detachMedia();
    } else {
      log.warn(HLS_IMPROPER_SETUP);
    }
  }
}
